import { IGroupEntityDTO } from '@modeso/types__aumico-lib-templates-be';
import { Subject } from 'rxjs';

export interface IGroupFormData {
    activeGroup: IGroupEntityDTO;
    groupNameExistsError?: Subject<string>;
}
